{
  "appName": "Designation Of Certifying Official(S)",
  "entryFile": "./app-entry.jsx",
  "entryName": "8794-edu-benefits",
  "rootUrl": "/school-administrators/update-certifying-officials",
  "productId": "bc4e797d-2a35-40f2-b072-66962e75fe89"
}
